/* Portefeuille rebranded — cross-sell « Ajouter Le Tracker ».
   Cible : la puce « Compatible avec Le Tracker » sous l'ATC ([data-wallet-add-tracker])
   et le bloc bas de page .mp-compare__proof (converti en CTA cross-sell).
   Ajoute 1 Tracker (variante Apple) via la vraie API panier Shopify puis ouvre
   le cart drawer. Aucune navigation produit. Chargé UNIQUEMENT par
   blocks/wallet-native-bundle.liquid (donc jamais sur le Tracker). */
(function () {
  var host = document.querySelector('.mp-wallet-bundle');
  if (!host) return;

  var TRACKER_APPLE = host.dataset.trackerApple || '';
  var TRACKER_ANDROID = host.dataset.trackerAndroid || '';
  var busy = false;

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!drawer.classList.contains('active')) {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function replaceSection(id, html) {
    if (!html) return;
    var current = document.getElementById(id);
    var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  }

  function renderCart(payload) {
    var sections = payload && payload.sections;
    if (sections) {
      replaceSection('CartDrawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
      var drawer = document.querySelector('cart-drawer');
      var rendered = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('cart-drawer');
      if (drawer && rendered) drawer.classList.toggle('is-empty', rendered.classList.contains('is-empty'));
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
  }

  function addTracker(trigger) {
    if (busy) return;
    /* Variante explicite portée par le bouton (data-variant="apple|android").
       Défaut Apple uniquement pour la puce générique « Compatible avec Le Tracker ». */
    var key = (trigger && trigger.dataset && trigger.dataset.variant) || 'apple';
    var variantId = Number(key === 'android' ? TRACKER_ANDROID : TRACKER_APPLE);
    if (!variantId) return;
    busy = true;
    if (trigger) trigger.classList.add('is-loading');
    /* on n'ouvre plus le tiroir avant la réponse (même correctif que sur les 3
       boutons "AJOUTER AU PANIER" à offres) : le chip garde son propre indicateur
       .is-loading, le tiroir ne s'ouvre qu'une fois rempli. */
    var drawer = document.querySelector('cart-drawer');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { '_Ajout populaire': key === 'android' ? 'Avec Le Portefeuille — Android' : 'Avec Le Portefeuille — Apple' }
        }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (payload) {
        renderCart(payload);
        if (drawer) drawer.classList.remove('mp-cart-pending');
        openCartDrawer();
      })
      .catch(function () {
        if (drawer) drawer.classList.remove('mp-cart-pending');
      })
      .finally(function () {
        busy = false;
        if (trigger) trigger.classList.remove('is-loading');
      });
  }

  function wire(el) {
    if (!el || el.dataset.mpXsellWired === 'true') return;
    el.dataset.mpXsellWired = 'true';
    el.classList.add('mp-xsell');
    if (el.tagName !== 'BUTTON' && el.tagName !== 'A') {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) return;
      e.preventDefault();
      addTracker(el);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); addTracker(el); }
    });
  }

  var GLYPH_APPLE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.7 13.1c0-2.7 2.2-4 2.3-4.1-1.3-1.8-3.2-2.1-3.9-2.1-1.7-.2-3.2 1-4.1 1-.9 0-2.2-1-3.7-1-1.9 0-3.7 1.1-4.7 2.8-2 3.5-.5 8.7 1.4 11.5.9 1.4 2.1 2.9 3.6 2.8 1.4-.1 2-1 3.7-1s2.2 1 3.7 1c1.5 0 2.5-1.4 3.5-2.8 1.1-1.6 1.5-3.2 1.5-3.3-.1 0-3.3-1.3-3.3-4.8ZM14 5.2c.8-1 1.4-2.4 1.2-3.7-1.2.1-2.7.8-3.6 1.8-.8.9-1.5 2.3-1.3 3.6 1.4.1 2.8-.7 3.7-1.7Z"/></svg>';
  var GLYPH_ANDROID = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 9.6A1.4 1.4 0 0 0 4.6 11v4.6A1.4 1.4 0 0 0 6 17h.6v2.4a1.4 1.4 0 0 0 2.8 0V17h5.2v2.4a1.4 1.4 0 0 0 2.8 0V17h.6a1.4 1.4 0 0 0 1.4-1.4V11A1.4 1.4 0 0 0 18 9.6H6ZM3 11.4A1.4 1.4 0 0 0 1.6 12.8v3a1.4 1.4 0 0 0 2.8 0v-3A1.4 1.4 0 0 0 3 11.4Zm18 0a1.4 1.4 0 0 0-1.4 1.4v3a1.4 1.4 0 0 0 2.8 0v-3A1.4 1.4 0 0 0 21 11.4ZM6.3 8.6h11.4c-.16-2-1.28-3.72-2.94-4.76l1.1-1.7a.36.36 0 0 0-.6-.4l-1.13 1.74A6.7 6.7 0 0 0 12 2.9c-.9 0-1.75.17-2.53.5L8.34 1.74a.36.36 0 1 0-.6.4l1.1 1.7C7.18 4.88 6.06 6.6 5.9 8.6h.4ZM9.4 6.1a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4Zm5.2 0a.7.7 0 1 1 0-1.4.7.7 0 0 1 0 1.4Z"/></svg>';

  function enhanceProof(proof) {
    if (proof.dataset.mpProofDone === 'true') return;
    proof.dataset.mpProofDone = 'true';
    proof.querySelectorAll('a[href]').forEach(function (a) {
      a.removeAttribute('href');
      a.setAttribute('role', 'presentation');
    });
    /* 2 CTA (Apple / Android) déjà rendus côté serveur (template le-portefeuille-rebranded).
       Ils portent data-wallet-add-tracker → câblés par boot() forEach(wire).
       Le conteneur .mp-compare__proof n'est PAS rendu cliquable (pas de défaut
       Apple ambigu au clic sur la carte). */
    if (proof.querySelector('.mp-xsell__actions')) return;
    var p = proof.querySelector('p');
    if (p && !p.querySelector('.mp-xsell__glyphs')) {
      var glyphs = document.createElement('span');
      glyphs.className = 'mp-xsell__glyphs';
      glyphs.setAttribute('aria-hidden', 'true');
      glyphs.innerHTML = GLYPH_APPLE + GLYPH_ANDROID;
      var sub = p.querySelector('span');
      if (sub) sub.insertAdjacentElement('afterend', glyphs);
      else p.appendChild(glyphs);
    }
    if (p && !p.querySelector('.mp-xsell__cta')) {
      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'mp-xsell__cta';
      cta.innerHTML = 'Add <span aria-hidden="true">+</span>';
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addTracker(cta);
      });
      p.appendChild(cta);
    }
  }

  function boot() {
    document.querySelectorAll('[data-wallet-add-tracker]').forEach(wire);
    /* Bloc bas de page : sur le template Portefeuille les 2 CTA sont rendus
       côté serveur (déjà câblés ci-dessus). enhanceProof ne fait plus que
       neutraliser d'éventuels liens ; fallback JS conservé si le markup serveur
       est absent. */
    var proof = document.querySelector('.mp-compare__proof');
    if (proof) {
      enhanceProof(proof);
      if (!proof.querySelector('.mp-xsell__actions')) wire(proof);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
